import React from "react";
import { usePage } from "@inertiajs/react";
import Header from "../../commons/Header";
import Footer from "../../commons/Footer";
import Content from "./Content";
import PortalApp from "../../portal/App";
import ProvideUserInfo from "../../providers/ProvideUserInfo";
import ProvideAffiliatorMyInfo from "../../providers/ProvideAffiliatorMyInfo";
import ProvideModal from "../../providers/ProvideModal";
import ProvideBalanceLog from "./ProvideBalanceLog";
import ProvidePopupable from "../../providers/ProvidePopupable";
import { LoggedInUserContext } from "../../providers/ProvideLoggedInUser";

const InnerComponent = () => {
  const { signedIn, loading } = React.use(LoggedInUserContext);
  const pageProps = usePage().props || {};
  const usePortal = !!pageProps.portal_shell;

  React.useEffect(() => {
    if (!loading && !signedIn) {
      // Get locale from current URL or default to 'id'
      const urlParams = new URLSearchParams(window.location.search);
      const locale = urlParams.get("locale") || "id";

      // Standalone login page preserves redirect_after_login so users return
      // to /users/affiliators after auth (which bounces to /affiliators via
      // the `/users/communities`-style Rails route).
      const redirectUrl = `/login?locale=${locale}&redirect_after_login=%2Fusers%2Faffiliators`;
      window.location.href = redirectUrl;
    }
  }, [signedIn, loading]);

  // Wait for auth to resolve before rendering or redirecting
  if (loading) return null;

  // Don't render content if user is not signed in (will redirect)
  if (!signedIn) {
    return null;
  }

  // Toggle ON: render inside the unified portal shell so the affiliator
  // page sits alongside Profil/Aktivitas/Langganan/Sertifikat with the
  // same sub-nav + hero. Toggle OFF: keep the original Header→Content→
  // Footer flow so legacy users see no change.
  if (usePortal) {
    return (
      <PortalApp
        theme={pageProps.theme || "light"}
        active="afiliator"
        tabs={pageProps.tabs}
        user={pageProps.user}
        subscription={pageProps.subscription}
        completeness={pageProps.completeness}
      >
        <Content />
      </PortalApp>
    );
  }

  return (
    <React.Fragment>
      <Header />
      <Content />
      <Footer />
    </React.Fragment>
  );
};

const UnnamedComponent = (props) => {
  let ret = <InnerComponent />;
  ret = <ProvideUserInfo>{ret}</ProvideUserInfo>;
  ret = <ProvideAffiliatorMyInfo>{ret}</ProvideAffiliatorMyInfo>;
  ret = <ProvideModal>{ret}</ProvideModal>;
  ret = <ProvideBalanceLog>{ret}</ProvideBalanceLog>;
  ret = <ProvidePopupable>{ret}</ProvidePopupable>;
  return ret;
};

export default UnnamedComponent;
